import auth from "../../middlewares/auth";

export const chatSettingsRoute = [
    {
        path: '/chat-categories',
        component: () => import(/* webpackChunkName: "chat_settings" */ '../../views/settings/chat_category/Index'),
        name: 'chat_categories',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['chat-setting-manage']
        }
    },
    {
        path: '/chat-settings',
        component: () => import(/* webpackChunkName: "chat_settings" */ '../../views/settings/chat_settings/Index'),
        name: 'chat_settings',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['chat-setting-manage']
        }
    },
];